module.exports = __webpack_public_path__ + "static/img/5.71c11a8.png";


//////////////////
// WEBPACK FOOTER
// ./static/banner2/5.png
// module id = epiN
// module chunks = 14